"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var _utils = require("@/helpers/utils");

var _fileSaver = require("file-saver");

var _moment = _interopRequireDefault(require("moment"));

var _listSecteurActMultiple = _interopRequireDefault(require("@/components/listSecteurActMultiple"));

var _listSecteurGeoMultiple = _interopRequireDefault(require("@/components/listSecteurGeoMultiple"));

var _listClient = _interopRequireDefault(require("@/components/listClient"));

var _listEnseigne = _interopRequireDefault(require("@/components/listEnseigne"));

var _exportModuleMixin = _interopRequireDefault(require("@/mixins/exportModuleMixin"));

var _exportListMixin = _interopRequireDefault(require("@/mixins/exportListMixin"));

var Excel = _interopRequireWildcard(require("exceljs"));

var _StickyTable = _interopRequireDefault(require("@/components/StickyTable.vue"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination.vue"));

var _ScrollBar = _interopRequireDefault(require("@/components/ScrollBar.vue"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'SyntheseList',
  components: {
    StickyTable: _StickyTable.default,
    Pagination: _Pagination.default,
    ScrollBar: _ScrollBar.default,
    listSecteurActMultiple: _listSecteurActMultiple.default,
    ListClient: _listClient.default,
    ListEnseigne: _listEnseigne.default,
    listSecteurGeoMultiple: _listSecteurGeoMultiple.default
  },
  mixins: [_exportModuleMixin.default, _exportListMixin.default],
  data: function data() {
    return {
      dataTable: [],
      currentPage: 1,
      pageSize: 100,
      show: false,
      activeFilter: '',
      affaires: {
        options: [],
        list: [],
        loading: false
      },
      columnSelected: {
        affaire: {
          client: true,
          numero: true,
          nom: true,
          secteurAct: true,
          enseigne: true,
          secteurGeo: true,
          codeAnalytique: true
        },
        commande: {
          numero: true,
          date: true,
          nbFacture: true,
          avancement: true,
          soldeHtAFacturer: true,
          emetteur: true,
          libelle: true,
          commentaire: true
        },
        facture: {
          libelle: true,
          numero: true,
          dateFacture: true,
          montantHt: true,
          montantTva: true,
          retenueGarantie: true,
          mtAvantPaiementDirectTtc: true,
          mtPaiementDirectSt: true,
          mtAPercevoirTtc: true,
          mtDiversTtc: true,
          dateEcheance: true,
          solde: true,
          commentaire: true
        },
        reglement: {
          date: true,
          montant: true
        }
      },
      columns: {
        // affaire
        'affaire.nom': {
          key: 0,
          prop: 'affaire_nom',
          label: 'Nom affaire',
          width: 450
        },
        'affaire.code_analytique': {
          key: 1,
          prop: 'affaire_code_analytique',
          label: 'Code analytique',
          width: 200
        },
        'affaire.num_affaire': {
          key: 2,
          prop: 'affaire_num_affaire',
          label: 'N° affaire',
          width: 300
        },
        'affaire.secteur_act_code': {
          key: 3,
          prop: 'secteur_act_code',
          label: 'Code act.',
          width: 70
        },
        'affaire.secteur_geo_code': {
          key: 4,
          prop: 'secteur_geo_code',
          label: 'Code ets.',
          width: 150
        },
        'affaire.secteur_geo_libelle': {
          key: 5,
          prop: 'secteur_geo_libelle',
          label: 'Code ets.',
          width: 150
        },
        // client
        'client': {
          key: 6,
          prop: 'client_libelle',
          label: 'Client',
          width: 200
        },
        // commande
        'commande.avancement': {
          key: 7,
          prop: 'commande_avancement',
          label: 'Avancement',
          width: 80
        },
        'commande.date': {
          key: 8,
          prop: 'commande_date',
          label: 'Date',
          width: 110
        },
        'commande.emetteur': {
          key: 9,
          prop: 'commande_emetteur',
          label: 'Emetteur',
          width: 230
        },
        'commande.montant': {
          key: 10,
          prop: 'commande_montant',
          label: 'Montant',
          width: 120
        },
        'commande.nb_facture': {
          key: 11,
          prop: 'commande_nb_facture',
          label: 'Nb facture',
          width: 70
        },
        'commande.numero': {
          key: 12,
          prop: 'commande_numero',
          label: 'N°',
          width: 150
        },
        'commande.solde_ht_a_facturer': {
          key: 13,
          prop: 'commande_solde_ht_a_facturer',
          label: 'Solde ht à facturer',
          width: 120
        },
        'commande.libelle': {
          key: 14,
          prop: 'commande_libelle',
          label: 'Libellé commande',
          width: 400
        },
        'commande.commentaire': {
          key: 16,
          prop: 'commande_commentaire',
          label: 'Commentaire',
          width: 250
        },
        // enseigne
        'enseigne': {
          key: 15,
          prop: 'enseigne_libelle',
          label: 'Enseigne',
          width: 300
        },
        // facture
        // 'facture.commentaire': { key: 16, prop: 'facture_commentaire', label: 'Commentaire', width: 250 },
        'facture.date_echeance': {
          key: 17,
          prop: 'facture_date_echeance',
          label: 'Échéance',
          width: 110
        },
        'facture.date_facture': {
          key: 18,
          prop: 'facture_date_facture',
          label: 'Date',
          width: 110
        },
        'facture.libelle': {
          key: 19,
          prop: 'facture_libelle',
          label: 'Libellé facture',
          width: 400
        },
        'facture.montant_ht': {
          key: 20,
          prop: 'facture_montant_ht',
          label: 'HT facturé',
          width: 120
        },
        'facture.montant_tva': {
          key: 21,
          prop: 'facture_montant_tva',
          label: 'TVA facturé',
          width: 120
        },
        'facture.mt_a_percevoir_ttc': {
          key: 22,
          prop: 'facture_mt_a_percevoir_ttc',
          label: 'TTC après P.D.',
          width: 120
        },
        'facture.mt_avant_paiement_direct_ttc': {
          key: 23,
          prop: 'facture_mt_avant_paiement_direct_ttc',
          label: 'TTC avant P.D.',
          width: 120
        },
        'facture.mt_paiement_direct_st': {
          key: 24,
          prop: 'facture_mt_paiement_direct_st',
          label: 'Montant P.D.',
          width: 120
        },
        'facture.mt_regle': {
          key: 25,
          prop: 'facture_mt_regle',
          label: 'Montant',
          width: 120
        },
        'facture.numero': {
          key: 26,
          prop: 'facture_numero',
          label: 'Numéro',
          width: 110
        },
        'facture.retenue_garantie': {
          key: 27,
          prop: 'facture_retenue_garantie',
          label: 'R.G.',
          width: 120
        },
        'facture.solde': {
          key: 28,
          prop: 'facture_solde',
          label: 'Solde restant dû',
          width: 120
        },
        'facture.divers_ttc': {
          key: 29,
          prop: 'facture_divers_ttc',
          label: 'Montant co-traitance',
          width: 120
        },
        // reglement
        'reglement.date': {
          key: 30,
          prop: 'reglement_date',
          label: 'Date',
          width: 110
        },
        'reglement.mode': {
          key: 31,
          prop: 'reglement_mode',
          label: 'Mode',
          width: 100
        },
        'reglement.montant': {
          key: 32,
          prop: 'reglement_montant',
          label: 'Montant',
          width: 120
        }
      },
      dialogDetailVisible: false,
      dialogFactureCommentaireVisible: false,
      sortMethod: {
        facture_numero: function facture_numero(a, b) {
          var numA = a.split('.').map(Number);
          var numB = b.split('.').map(Number);

          for (var i = 0; i < Math.max(numA.length, numB.length); i++) {
            var partA = numA[i] || 0; // Si une partie est absente, considérer comme 0

            var partB = numB[i] || 0;

            if (partA !== partB) {
              return partA - partB; // Trier par différence numérique
            }
          }

          return 0; // Si tous les segments sont égaux
        },
        reglement_date: function reglement_date(a, b) {
          if (a === null && b === null) {
            return 0;
          }

          if (a === null) {
            return -1;
          }

          if (b === null) {
            return 1;
          }

          return a > b ? 1 : a < b ? -1 : 0;
        },
        facture_commentaire: function facture_commentaire(a, b) {
          if (a === null && b === null) {
            return 0;
          }

          if (a === null) {
            return -1;
          }

          if (b === null) {
            return 1;
          }

          return a > b ? 1 : a < b ? -1 : 0;
        },
        commande_numero: function commande_numero(a, b) {
          if (a === null && b === null) {
            return 0;
          }

          if (a === null) {
            return -1;
          }

          if (b === null) {
            return 1;
          }

          return a > b ? 1 : a < b ? -1 : 0; // return a.numero < b.numero
        },
        commande_commentaire: function commande_commentaire(a, b) {
          if (a === null && b === null) {
            return 0;
          }

          if (a === null) {
            return -1;
          }

          if (b === null) {
            return 1;
          }

          return a > b ? 1 : a < b ? -1 : 0;
        }
      },
      filters: [// Filtre #0 : filtre sur secteur d'activité
      {
        value: [],
        prop: ['secteur_act_id'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'secteur_act_id':
                if (filter.value.length === 0) {
                  return true;
                }

                return filter.value.includes(row.affaire.secteur_act.id);

              default:
                return false;
            }
          });
        }
      }, // Filtre #1 : filtre sur le client
      {
        value: null,
        prop: ['client_id'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'client_id':
                if (filter.value === null) {
                  return true;
                }

                return row.affaire.client.id === filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #2 : filtre sur l'enseigne
      {
        value: null,
        prop: ['enseigne_id'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'enseigne_id':
                if (filter.value === null) {
                  return true;
                }

                return row.affaire.enseigne.id === filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #3 : filtre sur secteur géographique
      {
        value: [],
        prop: ['secteur_geo_id'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'secteur_geo_id':
                if (filter.value.length === 0) {
                  return true;
                } // console.log('secteur_geo_id : row.affaire.secteur_geo.id === filter.value', row.affaire.secteur_geo.id, filter.value, filter.value.includes(row.affaire.secteur_geo.id))


                return filter.value.includes(row.affaire.secteur_geo.id);

              default:
                return false;
            }
          });
        }
      }, // Filtre #4 : recherche sur le numéro de l'affaire
      {
        value: '',
        prop: ['affaire'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'affaire':
                var numAffaire = row.affaire.num_affaire.toLowerCase();
                return numAffaire.indexOf(filter.value.toLowerCase()) > -1;

              default:
                return false;
            }
          });
        }
      }, // Filtre #5 : si le n° de commande >= n° saisie
      {
        value: '',
        prop: ['commande_numero'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_numero':
                if (filter.value === '') {
                  return true;
                }

                return row.commande.numero >= filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #6 : si le n° de commande <= n° saisie
      {
        value: '',
        prop: ['commande_numero'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_numero':
                if (filter.value === null) {
                  return true;
                }

                return row.commande.numero <= filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #7 : si la date de commande est >= date de début de période
      {
        value: '',
        prop: ['commande_date'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_date':
                if (filter.value === null) {
                  return true;
                }

                var date = row.commande.date;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrAfter(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #8 : si la date de commande est <= date de fin de période
      {
        value: '',
        prop: ['commande_date'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_date':
                if (filter.value === null) {
                  return true;
                }

                var date = row.commande.date;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrBefore(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #9 : si le nb facture / commande est >= nombre saisie
      {
        value: '',
        prop: ['commande_nb_facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_nb_facture':
                if (filter.value === null) {
                  return true;
                }

                var nb = row.commande.nb_facture;
                return nb >= Number.parseInt(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #10 : si le nb facture / commande est <= nombre saisie
      {
        value: '',
        prop: ['commande_nb_facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_nb_facture':
                if (filter.value === null) {
                  return true;
                }

                var nb = row.commande.nb_facture;
                return nb <= Number.parseInt(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #11 : si le %age avancement / commande est >= nombre saisie
      {
        value: '',
        prop: ['commande_avancement'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_avancement':
                if (filter.value === null) {
                  return true;
                }

                var nb = row.commande.avancement * 100;
                return nb >= Number.parseFloat(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #12 : si le %age avancement <= nombre saisie
      {
        value: '',
        prop: ['commande_avancement'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_avancement':
                if (filter.value === null) {
                  return true;
                }

                var nb = row.commande.avancement * 100;
                return nb <= Number.parseFloat(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #13 : si le solde HT à facturer / commande est >= montant saisie
      {
        value: '',
        prop: ['commande_solde_ht_a_facturer'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_solde_ht_a_facturer':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.commande.solde_ht_a_facturer;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #14 : si le solde HT à facturer / commande est <= montant saisie
      {
        value: '',
        prop: ['commande_solde_ht_a_facturer'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_solde_ht_a_facturer':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.commande.solde_ht_a_facturer;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #15 : si le n° de facture >= n° saisie
      {
        value: '',
        prop: ['facture_numero'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_numero':
                if (filter.value === '') {
                  return true;
                }

                return row.facture.numero >= filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #16 : si le n° de facture <= n° saisie
      {
        value: '',
        prop: ['facture_numero'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_numero':
                if (filter.value === null) {
                  return true;
                }

                return row.facture.numero <= filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #17 : si la date de facture est >= date de début de période
      {
        value: '',
        prop: ['facture_date_facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_date_facture':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_facture;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrAfter(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #18 : si la date de facture est <= date de fin de période
      {
        value: '',
        prop: ['facture_date_facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_date_facture':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_facture;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrBefore(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #19 : si le montant HT de la facture est >= montant saisie
      {
        value: '',
        prop: ['facture_montant_ht'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_montant_ht':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.montant_ht;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #20 : si le montant HT de la facture est <= montant saisie
      {
        value: '',
        prop: ['facture_montant_ht'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_montant_ht':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.montant_ht;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #21 : si le montant de TVA de la facture est >= montant saisie
      {
        value: '',
        prop: ['facture_montant_tva'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_montant_tva':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.montant_tva;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #22 : si le montant de TVA de la facture est <= montant saisie
      {
        value: '',
        prop: ['facture_montant_tva'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_montant_tva':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.montant_tva;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #23 : si la retenue de garantie de la facture est >= montant saisie
      {
        value: '',
        prop: ['facture_retenue_garantie'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_retenue_garantie':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.retenue_garantie;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #24 : si la retenue de garantie de la facture est <= montant saisie
      {
        value: '',
        prop: ['facture_retenue_garantie'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_retenue_garantie':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.retenue_garantie;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #25 : si le montant TTC avant P.D. de la facture est >= montant saisie
      {
        value: '',
        prop: ['facture_mt_avant_paiement_direct_ttc'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_mt_avant_paiement_direct_ttc':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_avant_paiement_direct_ttc;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #26 : si le montant TTC avant P.D. de la facture est <= montant saisie
      {
        value: '',
        prop: ['facture_mt_avant_paiement_direct_ttc'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_mt_avant_paiement_direct_ttc':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_avant_paiement_direct_ttc;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #27 : si le montant du P.D. de la facture est >= montant saisie
      {
        value: '',
        prop: ['facture_mt_paiement_direct_st'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_mt_paiement_direct_st':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_paiement_direct_st;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #28 : si le montant du P.D. de la facture est <= montant saisie
      {
        value: '',
        prop: ['facture_mt_paiement_direct_st'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_mt_paiement_direct_st':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_paiement_direct_st;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #29 : si le montant TTC propre après P.D. de la facture est >= montant saisie
      {
        value: '',
        prop: ['facture_mt_a_percevoir_ttc'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_mt_a_percevoir_ttc':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_a_percevoir_ttc;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #30 : si le montant TTC propre après P.D. de la facture est <= montant saisie
      {
        value: '',
        prop: ['facture_mt_a_percevoir_ttc'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_mt_a_percevoir_ttc':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_a_percevoir_ttc;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #31 : si la date d'échéance est >= date de début de période
      {
        value: '',
        prop: ['facture_date_echeance'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_date_echeance':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_echeance;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrAfter(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #32 : si la date d'échéance est <= date de fin de période
      {
        value: '',
        prop: ['facture_date_echeance'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_date_echeance':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_echeance;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrBefore(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #33 : si le montant du règlement est >= montant saisie
      {
        value: '',
        prop: ['reglement_montant'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'reglement_montant':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.reglement.montant;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #34 : si le montant du règlement est <= montant saisie
      {
        value: '',
        prop: ['reglement_montant'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'reglement_montant':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.reglement.montant;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #35 : si la date de règlement est >= date de début de période
      {
        value: '',
        prop: ['reglement_date'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'reglement_date':
                if (filter.value === null) {
                  return true;
                }

                var date = row.reglement.date;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrAfter(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #36 : si la date de règlement est <= date de fin de période
      {
        value: '',
        prop: ['reglement_date'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'reglement_date':
                if (filter.value === null) {
                  return true;
                }

                var date = row.reglement.date;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrBefore(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #37 : si le solde de la facture est >= montant saisie
      {
        value: '',
        prop: ['facture_solde'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_solde':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.solde;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #38 : si le solde de la facture est <= montant saisie
      {
        value: '',
        prop: ['facture_solde'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_solde':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.solde;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #39 : recherche dans le contenu des commentaires des factures

      /*
      {
        value: '',
        prop: ['facture_commentaire'],
        filterFn: (row, filter) => {
          return Object.keys(row).some(prop => {
            switch (prop) {
              case 'facture_commentaire':
                if (row.facture.commentaire === null) {
                  return false
                }
                const commentaire = row.facture.commentaire.toLowerCase()
                return commentaire.indexOf(filter.value.toLowerCase()) > -1
              default:
                return false
            }
          })
        }
      },
      */
      {
        value: '',
        prop: ['commande_commentaire'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_commentaire':
                if (row.commande.commentaire === null) {
                  return false;
                }

                var commentaire = row.commande.commentaire.toLowerCase();
                return commentaire.indexOf(filter.value.toLowerCase()) > -1;

              default:
                return false;
            }
          });
        }
      }, // Filtre #40 : recherche dans l'émetteur des commandes
      {
        value: '',
        prop: ['commande_emetteur'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_emetteur':
                if (row.commande.emetteur === null) {
                  return false;
                }

                var text = row.commande.emetteur.toLowerCase();
                return text.indexOf(filter.value.toLowerCase()) > -1;

              default:
                return false;
            }
          });
        }
      }, // Filtre #41 : si le code analytique >= n° saisie
      {
        value: '',
        prop: ['affaire_code_analytique'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'affaire_code_analytique':
                if (filter.value === '') {
                  return true;
                }

                return row.affaire.code_analytique >= filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #42 : si le code analytique <= n° saisie
      {
        value: '',
        prop: ['affaire_code_analytique'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'affaire_code_analytique':
                if (filter.value === null) {
                  return true;
                }

                return row.affaire.code_analytique <= filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #43 : recherche dans le libellé des factures
      {
        value: '',
        prop: ['facture_libelle'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_libelle':
                if (row.facture.libelle === null) {
                  return false;
                }

                var text = row.facture.libelle.toLowerCase();
                return text.indexOf(filter.value.toLowerCase()) > -1;

              default:
                return false;
            }
          });
        }
      }, // Filtre #44 : recherche dans le nom de l'affaire
      {
        value: '',
        prop: ['affaire_nom'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'affaire_nom':
                if (row.affaire.nom === null) {
                  return false;
                }

                var text = row.affaire.nom.toLowerCase();
                return text.indexOf(filter.value.toLowerCase()) > -1;

              default:
                return false;
            }
          });
        }
      }, // Filtre #45 : recherche dans le libellé des commandes
      {
        value: '',
        prop: ['commande_libelle'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'commande_libelle':
                if (row.commande.libelle === null) {
                  return false;
                }

                var text = row.commande.libelle.toLowerCase();
                return text.indexOf(filter.value.toLowerCase()) > -1;

              default:
                return false;
            }
          });
        }
      }, // Filtre #46 : si le montant co-traitance de la facture est >= montant saisie
      {
        value: '',
        prop: ['facture_divers_ttc'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_divers_ttc':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture_divers_ttc;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #47 : si le montant co-traitance de la facture est <= montant saisie
      {
        value: '',
        prop: ['facture_divers_ttc'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_divers_ttc':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture_divers_ttc;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }],
      mixinEvents: {
        export: 'SYNTHESE_EXPORT',
        exported: 'SYNTHESE_EXPORTED'
      },
      multipleSelection: [],
      row: [],
      rowComment: {},
      rowSpan: {
        label: 4,
        selection: 1,
        field: 5
      }
    };
  },
  watch: {
    filters: {
      deep: true,
      handler: function handler(newValue) {
        this.getData();
      }
    },
    columnSelected: {
      deep: true,
      handler: function handler(newValue) {
        this.getData();
      }
    },
    'filters.1.value': function filters1Value(newVal, oldVal) {
      // Si on déselectionne le client
      if (newVal === null) {
        // On vide aussi la liste des enseignes liées
        this.filters[2].value = null;
      } // console.log('idClient has changed', newVal, oldVal)

    }
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {}, (0, _vuex.mapGetters)('facturation', ['getSyntheseList']), {
    columnGroupSelected: function columnGroupSelected() {
      var _this$columnSelected$ = this.columnSelected.affaire,
          secteurAct = _this$columnSelected$.secteurAct,
          numero = _this$columnSelected$.numero,
          dataAffaire = _objectWithoutProperties(_this$columnSelected$, ["secteurAct", "numero"]);

      var affaire = Object.values(dataAffaire).some(function (checked) {
        return checked === true;
      });
      var commande = Object.values(this.columnSelected.commande).some(function (checked) {
        return checked === true;
      });

      var _this$columnSelected$2 = this.columnSelected.facture,
          commentaire = _this$columnSelected$2.commentaire,
          dataFacture = _objectWithoutProperties(_this$columnSelected$2, ["commentaire"]);

      var facture = Object.values(dataFacture).some(function (checked) {
        return checked === true;
      });
      var reglement = Object.values(this.columnSelected.reglement).some(function (checked) {
        return checked === true;
      });
      return {
        affaire: affaire,
        commande: commande,
        facture: facture,
        reglement: reglement,
        one: affaire || commande || facture || reglement
      };
    },
    rowCommentHtml: function rowCommentHtml() {
      return (0, _utils.nl2br)(this.rowComment.commentaire);
    },
    dateFormat: function dateFormat() {
      return this.user.date_format; // dd/MM/yyyy
    },
    filterExists: function filterExists() {
      var filterExists = false;
      this.filters.forEach(function (x, index) {
        // console.log(index + '# typeof', x.value, typeof x.value)
        switch (_typeof(x.value)) {
          case 'string':
            if (x.value !== null && x.value !== '') {
              filterExists = true;
            }

            break;

          case 'number':
            if (x.value !== null && x.value > 0) {
              filterExists = true;
            }

            break;

          case 'object':
            if (x.value && x.value.length > 0) {
              filterExists = true;
            }

            break;
        }
      });
      return filterExists;
    },
    pageIdent: function pageIdent() {
      return "".concat(this.user.id_societe, "-VenteCreance-SyntheseGenerale");
    },
    total: function total() {
      return this.dataTable.length;
    }
  }),
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      var savedFilters, _JSON$parse, filters, columns;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Récupération des filtres et des colonnes sauvegardés
              savedFilters = localStorage.getItem("Filters_".concat(this.pageIdent));

              if (savedFilters) {
                _JSON$parse = JSON.parse(savedFilters), filters = _JSON$parse.filters, columns = _JSON$parse.columns;
                filters.forEach(function (row, index) {
                  _this.filters[index].value = row;
                });
                this.columnSelected = columns;
              }

              _context.next = 4;
              return this.loadSyntheseList();

            case 4:
              _context.next = 6;
              return this.getData();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  methods: _objectSpread({}, (0, _vuex.mapActions)('facturation', ['loadSyntheseList']), {
    getData: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var filters, columns;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // console.log('data called !!!')
                this.$loader(true);
                this.show = false; // Sauvegarde des filtres et de colonnes à afficher dans le localStorage

                filters = this.filters.map(function (filter) {
                  return filter.value;
                });
                columns = this.columnSelected;
                localStorage.setItem("Filters_".concat(this.pageIdent), JSON.stringify({
                  filters: filters,
                  columns: columns
                })); // Filtrage des données en fonction des filtres

                _context2.next = 7;
                return this.applyFilters();

              case 7:
                this.$loader(false);
                this.show = true;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    applyFilters: function applyFilters() {
      var _this2 = this;

      var data = this.getSyntheseList;
      var filteredData = data.filter(function (row) {
        return _this2.filters.every(function (filter) {
          if (!filter.value || filter.value === '') {
            // Si la valeur du filtre est vide, passer au suivant
            return true;
          } // Appliquer la fonction de filtre


          return filter.filterFn(row, filter);
        });
      }); // On affiche les factures mais pas les règlements

      if (this.columnGroupSelected.facture && !this.columnGroupSelected.reglement) {
        // console.log('starting deduplication facture ...', data.length, ' facture(s)')
        var newData = [];
        var factureList = [];
        filteredData.forEach(function (x, index) {
          if (!factureList.includes(x.facture.id)) {
            newData.push(x);
            factureList.push(x.facture.id);
          }
        });
        filteredData = newData; // console.log('end deduplication facture', data.length, ' facture(s)')
      } // On affiche uniquement les commandes


      if (this.columnGroupSelected.commande && !this.columnGroupSelected.facture && !this.columnGroupSelected.reglement) {
        // console.log('starting deduplication commande ...', data.length, ' commande(s)')
        var _newData = [];
        var commandeList = [];
        filteredData.forEach(function (x, index) {
          if (!commandeList.includes(x.commande.id)) {
            _newData.push(x);

            commandeList.push(x.commande.id);
          }
        });
        filteredData = _newData; // console.log('end deduplication commande', data.length, ' commande(s)')
      }

      this.dataTable = filteredData; // récupération de la liste des affaires pour l'autocomplétion du champ de recherche Num affaire

      var listAffaire = [];
      this.dataTable.forEach(function (row) {
        var value = row.affaire.num_affaire;
        var label = value;

        if (!listAffaire.find(function (item) {
          return item.value === value;
        })) {
          listAffaire.push({
            value: value,
            label: label
          });
        }
      });
      this.affaires.list = listAffaire;
    },
    generateExcelFile: function () {
      var _generateExcelFile = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var workbook, worksheet, columnHeaderListFiltered, cellStart, cellEnd, _cellStart, _cellEnd, _cellStart2, _cellEnd2, _cellStart3, _cellEnd3, style, cellFirst, cellLast, buffer, now, fileType, fileExtension, file, blob;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // console.log('[SyntheseList] generateExcelFile called!')
                // Classeur Excel
                workbook = new Excel.Workbook(); // Propriétés du classeur

                workbook.creator = 'Groupe MARRAUD - EASY';
                workbook.lastModifiedBy = 'Groupe MARRAUD - EASY'; // workbook.lastPrinted = ''

                workbook.created = new Date(); // workbook.modified = ''

                workbook.company = 'Groupe MARRAUD';
                workbook.manager = '';
                workbook.title = 'Export Synthèse Générale';
                workbook.subject = '';
                workbook.keywords = 'synthèse générale';
                workbook.category = '';
                workbook.description = 'Créances / Ventes : Synthèse générale'; // workbook.language = ''
                // workbook.revision = ''
                // workbook.contentStatus = ''
                // Forcer les calculs au chargement du classeur

                workbook.calcProperties.fullCalcOnLoad = true; // Feuille de calcul avec en-tête et pied de page

                worksheet = workbook.addWorksheet('Synthèse Générale', {
                  properties: {
                    defaultRowHeight: 15
                  },
                  headerFooter: {
                    firstHeader: 'Groupe MARRAUD - EASYs - &A',
                    firstFooter: '&L&D à &T&C&F&RPage &P sur &N'
                  },
                  views: [// Viger les volets sous la seconde ligne
                  {
                    state: 'frozen',
                    xSplit: 0,
                    ySplit: 2
                  }] // state: 'frozen',
                  // xSplit: 0,
                  // ySplit: 1,
                  // topLeftCell: 'A2'
                  // activeCell: 'A1',
                  // autoFilter: {
                  //   from: 'A1',
                  //   to: 'D1'
                  // }

                }); // Add column headers and define column keys and widths
                // Note: these column structures are a workbook-building convenience only,
                // apart from the column width, they will not be fully persisted.
                // Colonnes d'en-tête

                columnHeaderListFiltered = this.getColumnHeaderListFiltered(); // worksheet.getRow(2).values = columnHeaderList.map(x => x.header)

                worksheet.getRow(2).values = columnHeaderListFiltered.map(function (x) {
                  return x.header;
                }); // Cellules de la première ligne d'en-tête (certaines doivent être fusionnées)
                // Secteur d'activité

                /*
                if (this.columnSelected.affaire.secteurAct) {
                  const cell = this.getColumnHeaderByKey(columnHeaderListFiltered, 'secteur_act_code')
                  if (cell) {
                    // console.log(`${cell.c}2 --> Code act.`)
                    worksheet.getCell(`${cell.c}2`).value = 'Code act.'
                  }
                }
                */
                // Commande : cellules fusionnées

                if (this.columnGroupSelected.commande) {
                  cellStart = this.getFirstColumnHeaderByGroup(columnHeaderListFiltered, 'commande');
                  cellEnd = this.getLastColumnHeaderByGroup(columnHeaderListFiltered, 'commande');

                  if (cellStart && cellEnd) {
                    // console.log(`${cellStart.c}1:${cellEnd.c}1 --> Commande`)
                    worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                    worksheet.getCell("".concat(cellStart.c, "1")).value = 'Commande';
                  }
                } // N° Affaire

                /*
                if (this.columnSelected.affaire.numero) {
                  const cell = this.getColumnHeaderByKey(columnHeaderListFiltered, 'affaire_num_affaire')
                  if (cell) {
                    // console.log(`${cell.c}2 --> N° Affaire`)
                    worksheet.getCell(`${cell.c}2`).value = 'N° Affaire'
                  }
                }
                */
                // Facture : cellules fusionnées


                if (this.columnGroupSelected.facture) {
                  _cellStart = this.getFirstColumnHeaderByGroup(columnHeaderListFiltered, 'facture');
                  _cellEnd = this.getLastColumnHeaderByGroup(columnHeaderListFiltered, 'facture');

                  if (_cellStart && _cellEnd) {
                    // console.log(`${cellStart.c}1:${cellEnd.c}1 --> Facture`)
                    worksheet.mergeCells("".concat(_cellStart.c, "1:").concat(_cellEnd.c, "1"));
                    worksheet.getCell("".concat(_cellStart.c, "1")).value = 'Facture';
                  }
                } // Règlement : cellules fusionnées


                if (this.columnGroupSelected.reglement) {
                  _cellStart2 = this.getFirstColumnHeaderByGroup(columnHeaderListFiltered, 'reglement');
                  _cellEnd2 = this.getLastColumnHeaderByGroup(columnHeaderListFiltered, 'reglement');

                  if (_cellStart2 && _cellEnd2) {
                    // console.log(`${cellStart.c}1:${cellEnd.c}1 --> Règlement`)
                    worksheet.mergeCells("".concat(_cellStart2.c, "1:").concat(_cellEnd2.c, "1"));
                    worksheet.getCell("".concat(_cellStart2.c, "1")).value = 'Règlement';
                  }
                } // Commentaire

                /*
                if (this.columnSelected.affaire.numero) {
                  const cell = this.getColumnHeaderByKey(columnHeaderListFiltered, 'facture_commentaire')
                  if (cell) {
                    // console.log(`${cell.c}2 --> Commentaire`)
                    worksheet.getCell(`${cell.c}2`).value = 'Commentaire'
                  }
                }
                */
                // Affaire : cellules fusionnées


                if (this.columnGroupSelected.affaire) {
                  _cellStart3 = this.getFirstColumnHeaderByGroup(columnHeaderListFiltered, 'affaire');
                  _cellEnd3 = this.getLastColumnHeaderByGroup(columnHeaderListFiltered, 'affaire');

                  if (_cellStart3 && _cellEnd3) {
                    // console.log(`${cellStart.c}1:${cellEnd.c}1 --> Affaire`)
                    worksheet.mergeCells("".concat(_cellStart3.c, "1:").concat(_cellEnd3.c, "1"));
                    worksheet.getCell("".concat(_cellStart3.c, "1")).value = 'Affaire';
                  }
                } // Définition des colonnes d'en-tête
                // worksheet.columns = columnHeaderList


                worksheet.columns = columnHeaderListFiltered.map(function (x) {
                  return {
                    key: x.key,
                    width: x.width
                  };
                }); // Données
                // worksheet.addRows(this.data)
                // worksheet.addRows(this.$refs.dataTable.tableData)

                this.getPreparedDataForExport().forEach(function (row) {
                  worksheet.addRow(row);
                });
                /*
                // Totaux
                worksheet.addRow({
                  comp_name: 'Total',
                  address: '',
                  comp_codecomptable: '',
                  comp_payeur: '',
                  nb_portes: 0,
                  nb_interventions: 0,
                  nb_documents: 0,
                  nb_tickets: 0
                })
                 // Mémorisation du numéro de la dernière ligne
                // const rowCount = worksheet.rowCount
                 // Formule de calcul de la cellule "maître"
                worksheet.getCell(`E${rowCount}`).value = {
                  formula: `SUM(E2:E${rowCount - 1})`,
                  shareType: 'shared',
                  ref: `E${rowCount}:H${rowCount}`,
                  date1904: false
                }
                 // Application de la formule de calcul sur les cellules "esclaves"
                worksheet.getCell(`F${rowCount}`).value = { sharedFormula: `E${rowCount}`, date1904: false }
                worksheet.getCell(`G${rowCount}`).value = { sharedFormula: `E${rowCount}`, date1904: false }
                worksheet.getCell(`H${rowCount}`).value = { sharedFormula: `E${rowCount}`, date1904: false }
                */
                // Style et formatage génériques

                style = {
                  // en-tête
                  header: {
                    font: {
                      bold: true,
                      color: {
                        argb: 'FFFFFFFF'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FF000000'
                      }
                    },
                    alignment: {
                      vertical: 'middle',
                      horizontal: 'center'
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      left: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      bottom: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      right: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      }
                    }
                  },
                  // lignes paires
                  even: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFDDDDDD'
                      }
                    }
                  },
                  // lignes impaires
                  odd: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    }
                  }
                }; // Boucle sur les lignes de la feuille du classeur

                worksheet.eachRow(function (row, rowNumber) {
                  // Boucle sur les cellules de la ligne
                  row.eachCell({
                    includeEmpty: true
                  }, function (cell, colNumber) {
                    switch (rowNumber) {
                      // Ligne d'en-tête et de pied du tableur
                      case 1:
                      case 2:
                        // case rowCount:
                        cell.style = _objectSpread({}, style.header);
                        break;
                      // Données

                      default:
                        var columnStyle = columnHeaderListFiltered[colNumber - 1].style || {};
                        var cellStyle = {}; // Lignes paires

                        if (rowNumber % 2 === 0) {
                          cellStyle = _objectSpread({}, style.even);
                        } else {
                          cellStyle = _objectSpread({}, style.odd);
                        }

                        cell.style = Object.assign({}, cell.style, columnStyle, cellStyle);
                        break;
                    }
                  });
                });
                cellFirst = this.getFirstColumnHeader(columnHeaderListFiltered);
                cellLast = this.getLastColumnHeader(columnHeaderListFiltered); // Set an auto filter

                worksheet.autoFilter = {
                  from: "".concat(cellFirst.c, "2"),
                  to: "".concat(cellLast.c, "2")
                }; // Ecriture dans un nouveau buffer

                _context3.next = 28;
                return workbook.xlsx.writeBuffer();

              case 28:
                buffer = _context3.sent;
                // Paramètres du fichier généré dynamiquement
                now = (0, _utils.getDateNow)().format('YYYYMMDD-HHmmss'); // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'

                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                fileExtension = 'xlsx';
                file = "".concat(now, "-synthese-generale.").concat(fileExtension); // Création du Blob

                blob = new Blob([buffer], {
                  type: fileType
                }); // Servir le fichier via le navigateur client

                (0, _fileSaver.saveAs)(blob, file); // console.log('[SyntheseList] generateExcelFile called')

              case 35:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function generateExcelFile() {
        return _generateExcelFile.apply(this, arguments);
      }

      return generateExcelFile;
    }(),
    getPreparedDataForExport: function getPreparedDataForExport() {
      // On utilise les données pré-filtrées par le dataTable
      var data = this.$refs.dataTable.tableData;
      data.forEach(function (row) {
        // Dates
        // Attention : pour les transpositions de dates EN -> FR
        // on assigne la valeur transposée de row.{object}.date
        // à la propriété racine row.{object_prop_with_date}
        // sinon on transposerais à chaque fois la même date
        // et cela donnerait des dates invalides
        row.commande_date = row.commande.date ? (0, _utils.toDate)(row.commande.date) : null;
        row.facture_date_facture = row.facture.date_facture ? (0, _utils.toDate)(row.facture.date_facture) : null;
        row.facture_date_echeance = row.facture.date_echeance ? (0, _utils.toDate)(row.facture.date_echeance) : null;
        row.reglement_date = row.reglement.date ? (0, _utils.toDate)(row.reglement.date) : null; // Mode de règlement

        row.reglement_mode = row.reglement.mode ? (0, _utils.getLabelModeReglement)(row.reglement.mode) : null;
      });
      return data;
    },
    getColumnHeaderByKey: function getColumnHeaderByKey() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return data.find(function (x) {
        return x.key === key;
      });
    },
    getFirstColumnHeader: function getFirstColumnHeader() {
      var cells = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position < accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getLastColumnHeader: function getLastColumnHeader() {
      var cells = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position > accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getFirstColumnHeaderByGroup: function getFirstColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position < accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getLastColumnHeaderByGroup: function getLastColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position > accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getColumnHeaderListFiltered: function getColumnHeaderListFiltered() {
      var defaultStyles = {
        monetaire: {
          numFmt: '# ##0.00 "€";[Red]-# ##0.00 "€"',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        pourcentage: {
          numFmt: '##0.00%',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        date: {
          numFmt: 'dd/mm/yyyy',
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        },
        nombre: {
          numFmt: '0',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        }
      }; // Colonnes d'en-tête

      var columnHeaderList = [//
      {
        header: 'Code act.',
        visible: this.columnSelected.affaire.secteurAct,
        key: 'secteur_act_code',
        width: 10 + 4,
        style: {
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        },
        filterButton: true,
        c: 'A'
      }, // Commande
      {
        header: 'Date',
        group: 'commande',
        visible: this.columnSelected.commande.date,
        key: 'commande_date',
        width: 13,
        style: defaultStyles.date,
        c: 'B'
      }, {
        header: 'Numéro',
        group: 'commande',
        visible: this.columnSelected.commande.numero,
        key: 'commande_numero',
        width: 20,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'C'
      }, {
        header: 'Montant',
        group: 'commande',
        visible: this.columnGroupSelected.commande,
        key: 'commande_montant',
        width: 16,
        style: defaultStyles.monetaire,
        c: 'D'
      }, {
        header: 'Nb facture',
        group: 'commande',
        visible: this.columnSelected.commande.nbFacture,
        key: 'commande_nb_facture',
        width: 10 + 4,
        style: defaultStyles.nombre,
        c: 'E'
      }, {
        header: 'Avancement',
        group: 'commande',
        visible: this.columnSelected.commande.avancement,
        key: 'commande_avancement',
        width: 16,
        style: defaultStyles.pourcentage,
        c: 'F'
      }, {
        header: 'Solde ht à facturer',
        group: 'commande',
        visible: this.columnSelected.commande.soldeHtAFacturer,
        key: 'commande_solde_ht_a_facturer',
        width: 17 + 4,
        style: defaultStyles.monetaire,
        c: 'G'
      }, {
        header: 'Emetteur',
        group: 'commande',
        visible: this.columnSelected.commande.emetteur,
        key: 'commande_emetteur',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'H'
      }, {
        header: 'Libellé commande',
        group: 'commande',
        visible: this.columnSelected.commande.libelle,
        key: 'commande_libelle',
        width: 17,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'I'
      }, //
      {
        header: 'N° Affaire',
        visible: this.columnSelected.affaire.numero,
        key: 'affaire_num_affaire',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'J'
      }, // Factures
      {
        header: 'Date',
        group: 'facture',
        visible: this.columnSelected.facture.dateFacture,
        key: 'facture_date_facture',
        width: 13,
        style: defaultStyles.date,
        c: 'K'
      }, {
        header: 'Numéro',
        group: 'facture',
        visible: this.columnSelected.facture.numero,
        key: 'facture_numero',
        width: 20,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'L'
      }, {
        header: 'Libellé facture',
        group: 'facture',
        visible: this.columnSelected.facture.libelle,
        key: 'facture_libelle',
        width: 17,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'M'
      }, {
        header: 'HT facturé',
        group: 'facture',
        visible: this.columnSelected.facture.montantHt,
        key: 'facture_montant_ht',
        width: 17,
        style: defaultStyles.monetaire,
        c: 'N'
      }, {
        header: 'TVA facturé',
        group: 'facture',
        visible: this.columnSelected.facture.montantTva,
        key: 'facture_montant_tva',
        width: 17,
        style: defaultStyles.monetaire,
        c: 'O'
      }, {
        header: 'R.G.',
        group: 'facture',
        visible: this.columnSelected.facture.retenueGarantie,
        key: 'facture_retenue_garantie',
        width: 17,
        style: defaultStyles.monetaire,
        c: 'P'
      }, {
        header: 'TTC avant P.D.',
        group: 'facture',
        visible: this.columnSelected.facture.mtAvantPaiementDirectTtc,
        key: 'facture_mt_avant_paiement_direct_ttc',
        width: 17,
        style: defaultStyles.monetaire,
        c: 'Q'
      }, {
        header: 'P.D.',
        group: 'facture',
        visible: this.columnSelected.facture.mtPaiementDirectSt,
        key: 'facture_mt_paiement_direct_st',
        width: 17,
        style: defaultStyles.monetaire,
        c: 'R'
      }, {
        header: 'TTC après P.D.',
        group: 'facture',
        visible: this.columnSelected.facture.mtAPercevoirTtc,
        key: 'facture_mt_a_percevoir_ttc',
        width: 17,
        style: defaultStyles.monetaire,
        c: 'S'
      }, {
        header: 'Solde restant dû',
        group: 'facture',
        visible: this.columnSelected.facture.solde,
        key: 'facture_solde',
        width: 19,
        style: defaultStyles.monetaire,
        c: 'T'
      }, {
        header: 'Montant co-traitance',
        group: 'facture',
        visible: this.columnSelected.facture.mtDiversTtc,
        key: 'facture_divers_ttc',
        width: 19,
        style: defaultStyles.monetaire,
        c: 'U'
      }, {
        header: 'Échéance',
        group: 'facture',
        visible: this.columnSelected.facture.dateEcheance,
        key: 'facture_date_echeance',
        width: 13,
        style: defaultStyles.date,
        c: 'V'
      }, // Règlements
      {
        header: 'Date',
        group: 'reglement',
        visible: this.columnSelected.reglement.date,
        key: 'reglement_date',
        width: 13,
        style: defaultStyles.date,
        c: 'W'
      }, {
        header: 'Montant',
        group: 'reglement',
        visible: this.columnSelected.reglement.montant,
        key: 'reglement_montant',
        width: 17,
        style: defaultStyles.monetaire,
        c: 'X'
      }, {
        header: 'Mode',
        group: 'reglement',
        visible: this.columnGroupSelected.reglement,
        key: 'reglement_mode',
        width: 25,
        style: {
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        },
        c: 'Y'
      }, //
      // { header: 'Commentaire', visible: this.columnSelected.facture.commentaire, key: 'facture_commentaire', width: 80, style: { alignment: { vertical: 'top', wrapText: true } }, c: 'Z' },
      {
        header: 'Commentaire',
        visible: this.columnSelected.commande.commentaire,
        key: 'commande_commentaire',
        width: 80,
        style: {
          alignment: {
            vertical: 'top',
            wrapText: true
          }
        },
        c: 'Z'
      }, // Affaires
      {
        header: 'Code ets.',
        group: 'affaire',
        visible: this.columnSelected.affaire.secteurGeo,
        key: 'secteur_geo_code',
        width: 10 + 4,
        style: {
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        },
        c: 'AA'
      }, {
        header: 'Code analytique',
        group: 'affaire',
        visible: this.columnSelected.affaire.codeAnalytique,
        key: 'affaire_code_analytique',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'AB'
      }, {
        header: 'Nom',
        group: 'affaire',
        visible: this.columnSelected.affaire.nom,
        key: 'affaire_nom',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'AC'
      }, {
        header: 'Enseigne',
        group: 'affaire',
        visible: this.columnSelected.affaire.enseigne,
        key: 'enseigne_libelle',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'AD'
      }, {
        header: 'Client',
        group: 'affaire',
        visible: this.columnSelected.affaire.client,
        key: 'client_libelle',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        },
        c: 'AE'
      }];
      var columnName = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      columnName.push('AA');
      columnName.push('AB');
      columnName.push('AC');
      columnName.push('AD');
      columnName.push('AE');
      var columnHeaderListFiltered = columnHeaderList.filter(function (x) {
        return x.visible;
      });
      columnHeaderListFiltered.forEach(function (x, index) {
        x.c = columnName[index];
        x.position = index + 1;
      });
      return columnHeaderListFiltered;
    },

    /* ---------------------------------------
     *  Liste déroulante des actions
     * ---------------------------------------
     *
     *   - commentaire: ajout d'un commentaire à la facture
     *
     */
    handleCommand: function handleCommand(command) {
      switch (command.action) {
        case 'commentaire':
          // Afficher une fenêtre modale d'édition de commentaire
          this.rowComment = {
            id: command.row.facture.id,
            commentaire: command.row.commande.commentaire,
            numero: command.row.facture.numero
          };
          this.dialogFactureCommentaireVisible = true;
          break;
      }
    },
    searchAffaireByNumero: function searchAffaireByNumero(query) {
      var _this3 = this;

      if (query !== '') {
        this.affaires.loading = true;
        setTimeout(function () {
          _this3.affaires.loading = false;
          _this3.affaires.options = _this3.affaires.list.filter(function (item) {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.affaires.options = [];
      }
    },
    showNbReglement: function showNbReglement(reglements) {
      return "".concat(reglements.length, " r\xE8glement").concat(reglements.length > 1 ? 's' : '');
    }
  })
};
exports.default = _default;